import { __, Alert } from "modules/theme";
import React, { Component } from "react";
import PropTypes from "prop-types";
import APIManager from "modules/common/apiManager";
import {
  FormControl,
  FormGroup,
  ControlLabel,
  ModalFooter,
  Button,
  ButtonCommonTheme,
} from "modules/theme";
import { FormWrapper, FormColumn } from "modules/theme";
import { ModalForm, ModalFormContainer } from "../../../../theme";
import Select from "react-select-plus";
import { isAccess } from "../../../../common/utils";
import CommonManager, { debounce } from "../../../../../helpers/common";
import Creatable from "react-select-plus/lib/Creatable";
import SelectFilterAPI from "../../../../common/components/form/SelectFilterAPI";

const commonManager = new CommonManager();

export class STTModelAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `STT Model`;
    this.moduleUrl = `config/stt`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
  }
  setData(editData = {}) {
    editData = editData || {};
    this.state = {
      isLoading: false,
      type:
        editData && Array.isArray(editData.type) && editData.type.length > 0
          ? editData.type[0]._id
          : null,
      initialType: (editData && editData.type) || [],
      value: editData.value || "",
      label: editData.label || "",
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      type: "",
      value: "",
      label: "",
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(`${message}`);
      this.setState({ isLoading: false });
    }
  }

  saveData(e) {
    e.preventDefault();
    this.setState({ isLoading: true });
    let _this = this;
    let tData = {
      type: this.state.type,
      value: this.state.value,
      label: this.state.label,
    };
    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}/${this.props.editData._id}`,
        tData,
        (data) => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`${this.moduleName} updated successfully.`);
            this.setState({ isLoading: false });
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        "public",
        { id: this.props.editData._id },
        "PATCH"
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        (data) => {
          _this.setData();
          _this.props.update();
          _this.props.closeModal(true);
          Alert.success(`${this.moduleName} created successfully.`);
          this.setState({ isLoading: false });
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
          this.setState({ isLoading: false });
        },
        "public"
      );
    }
  }

  render() {
    const { modalType } = this.props;
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)}>
        <ModalFormContainer>
          <FormWrapper>
            <FormColumn>
              <FormGroup>
                <ControlLabel required>Type</ControlLabel>
                <SelectFilterAPI
                  dataUrl={"config/stt/provider"}
                  global={true}
                  selected={this.state.type}
                  initialValues={commonManager.initialData(
                    this.state.initialType,
                    "name",
                    "_id"
                  )}
                  dataValue={"value"}
                  dataLabel={"label"}
                  label={"Type"}
                  multi={false}
                  required={true}
                  onSelect={(items, name, ops) => {
                    if (items) {
                      this.setState({
                        type: items,
                        initialType: commonManager.selectedSingleData(
                          items,
                          ops
                        ),
                      });
                    } else {
                      this.setState({
                        type: null,
                      });
                    }
                  }}
                />
              </FormGroup>
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Display Name", {
                defaultValue: "",
                placeholder: "Display Name",
                autoFocus: false,
                required: true,
                id: "displayName",
                value: this.state.label,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    label: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Value", {
                defaultValue: "",
                placeholder: "Value",
                autoFocus: false,
                required: true,
                id: "Value",
                disabled:
                  this.props.editData && this.props.editData._id ? true : false,
                value: this.state.value,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    value: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type="greyModalBtn"
            // btnStyle="cancel"
            OnClick={() => this.props.closeModal()}
            size="xl"
            modalBtnTitle="Cancel"
          />
          <ButtonCommonTheme
            type="blueModalBtn"
            btnType="submit"
            isLoading={this.state.isLoading}
            disabled={this.state.isLoading}
            modalBtnTitle={
              this.props.editData && this.props.editData._id ? "Update" : "Add"
            }
          />
        </ModalFooter>
      </ModalForm>
    );
  }
}

STTModelAddEdit.propTypes = {
  group: PropTypes.array,
};

STTModelAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired,
};

export default STTModelAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/Org_setting/STTModel/components/STTModelAddEdit.js